import { render, staticRenderFns } from "./ViewSetting.vue?vue&type=template&id=f29c0d60&scoped=true&"
import script from "./ViewSetting.vue?vue&type=script&lang=js&"
export * from "./ViewSetting.vue?vue&type=script&lang=js&"
import style0 from "./ViewSetting.vue?vue&type=style&index=0&id=f29c0d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29c0d60",
  null
  
)

export default component.exports